import { BiTypography } from 'bi-web-components-react';
import { Programme } from '../../../types';
import { getTermTranslationKey } from '../../../utils';
import { useTranslation } from 'react-i18next';
import styles from './oneOptionContainer.module.scss';
import { BiIconCalendar, BiIconLocation, BiIconWorld, BiIconClock, BiIconSchool } from '@bi-digital/icons-react';
interface OneOptionContainerProps {
    programme: Programme;
}

export default function OneOptionContainer({ programme }: OneOptionContainerProps) {
    const { t } = useTranslation('cart');
    const { arrangements, teachingLanguage, campuses, credits } = programme;
    const residences = arrangements ? [...new Set(arrangements.map(({ residenceCode }) => residenceCode))] : [];
    const terms = arrangements ? [...new Set(arrangements.map(({ termCode }) => termCode))] : [];

    const teachingLanguageText = teachingLanguage === 'Norwegian' ? t('cart:nolanguage') : t('cart:enlanguage');

    const [term, year] = getTermTranslationKey(terms[0]);

    return (
        <div className={styles.container}>
            {campuses.length === 1 && (
                <span className={styles.itemContainer}>
                    <BiIconLocation size='medium' color='gray' title={`${t('cart:LocationSrOnly')} ${campuses[0]}`} />
                    <BiTypography>{campuses[0]}</BiTypography>
                </span>
            )}

            {residences.length === 1 && (
                <span className={styles.itemContainer}>
                    <BiIconClock
                        size='medium'
                        color='gray'
                        title={`${t('cart:StartDateSrOnly')} ${t(`cart:residence:${residences[0]}`)}`}
                    />
                    <BiTypography>{t(`cart:residence:${residences[0]}`)}</BiTypography>
                    <span className='sr-only' role='presentation'>
                        {`${t('cart:StartDateSrOnly')} ${t(`residence>${residences[0]}`)}`}
                    </span>
                </span>
            )}

            {terms.length === 1 && (
                <span className={styles.itemContainer}>
                    <BiIconCalendar size='medium' color='gray' aria-hidden='true' />
                    <BiTypography>
                        {t(`${term}`)} {year}
                    </BiTypography>
                    <span className='sr-only' role='presentation'>
                        {`${t('cart:StartDateSrOnly')} ${getTermTranslationKey(terms[0])}`}
                    </span>
                </span>
            )}
            {credits > 0 && (
                <span className={styles.itemContainer}>
                    <BiIconSchool
                        size='medium'
                        color='gray'
                        title={`${t('cart:CreditsSrOnly')}${credits} ${t('cart:credits')}`}
                    />
                    <BiTypography>{`${credits} ${t('cart:credits')}`}</BiTypography>
                    <span className='sr-only' role='presentation'>
                        {`${t('cart:CreditsSrOnly')}${credits} ${t('cart:credits')}`}
                    </span>
                </span>
            )}
            <span className={styles.itemContainer}>
                <BiIconWorld size='medium' color='gray' title={`${t('cart:LanguageSrOnly')} ${teachingLanguage}`} />
                <BiTypography>{teachingLanguageText}</BiTypography>
                <span className='sr-only' role='presentation'>{`${t('cart:LanguageSrOnly')} ${teachingLanguage}`}</span>
            </span>
        </div>
    );
}
